import axiosInstance from "../utils/axiosInstance";
import { telemetryClient } from "../../services/telemetryClient";

const ENDPOINT = "/text-transform/create";

export type TextTransformType =
  | "summary"
  | "letter"
  | "email"
  | "update"
  | "improve"
  | "fee-notes"
  | "custom";

interface CreateTextTransformResponse {
  message: string;
  jobId: string;
}

interface CreateTextTransformOptions {
  sourceText?: string;
  transformType: TextTransformType;
  customInstruction?: string;
  additionalContext?: string;
  filePasswords?: Record<string, string>;
  enableDocumentChat?: boolean;
}

export const createTextTransform = async (
  files: string[],
  options: CreateTextTransformOptions,
): Promise<CreateTextTransformResponse> => {
  const startedAt = Date.now();
  telemetryClient.log("job.createRequest.start", {
    metadata: { endpoint: ENDPOINT, transformType: options.transformType },
  });
  try {
    const response = await axiosInstance.post<CreateTextTransformResponse>(
      ENDPOINT,
      {
        files,
        ...(options.sourceText?.trim() ? { sourceText: options.sourceText.trim() } : {}),
        transformType: options.transformType,
        ...(options.customInstruction?.trim()
          ? { customInstruction: options.customInstruction.trim() }
          : {}),
        ...(options.additionalContext?.trim()
          ? { additionalContext: options.additionalContext.trim() }
          : {}),
        ...(options.filePasswords && Object.keys(options.filePasswords).length > 0
          ? { filePasswords: options.filePasswords }
          : {}),
        enableDocumentChat: !!options.enableDocumentChat,
      },
    );

    telemetryClient.log("job.createRequest.success", {
      jobId: response.data.jobId,
      metadata: { endpoint: ENDPOINT, durationMs: Date.now() - startedAt },
    });
    return response.data;
  } catch (error: any) {
    telemetryClient.log("job.createRequest.error", {
      level: "error",
      metadata: {
        endpoint: ENDPOINT,
        durationMs: Date.now() - startedAt,
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
      },
    });
    throw new Error(error.response?.data?.message || "Failed to create text transform.");
  }
};
